<template>
  <div class="row">
    <div class="col-md-12">
      <template v-if="media.sm">
        <el-descriptions :column="1" border direction="vertical">
          <template slot="title">
            <slot name="title"></slot>
          </template>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['far', 'id-card']"></font-awesome-icon>
              Rut
            </template>
            <span data-cy="affiliation-idcard">{{ rut | rutFormat }}</span>
          </el-descriptions-item>
          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['far', 'id-badge']"></font-awesome-icon>
              Nombre solicitante
            </template>
            <span data-cy="affiliation-fullname">{{ nombreCompleto }}</span>
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['far', 'calendar']"></font-awesome-icon>
              Fecha de ingreso
            </template>
            <span data-cy="affiliation-datetime">{{ fechaIngreso }}</span>
          </el-descriptions-item>
          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'envelope']"></font-awesome-icon>
              Correo electrónico
            </template>
            <span data-cy="affiliation-email">{{ email }}</span>
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item"
                                v-if="estadoRevision !== null">
            <template slot="label">
              <span class="el-icon-bell"></span>
              Estado de revisión
            </template>
            <el-tag :type="stateTag(codigoEstado)" data-cy="affiliation-state">{{ estadoRevision }}</el-tag>
          </el-descriptions-item>

        </el-descriptions>
      </template>
      <template v-else>
        <el-descriptions :column="4" border>
          <template slot="title">
            <slot name="title"></slot>
          </template>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['far', 'id-card']"></font-awesome-icon>
              Rut
            </template>
            <span data-cy="affiliation-idcard">{{ rut | rutFormat }}</span>
          </el-descriptions-item>
          <el-descriptions-item span="3" content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['far', 'id-badge']"></font-awesome-icon>
              Nombre solicitante
            </template>
            <span data-cy="affiliation-fullname">{{ nombreCompleto }}</span>
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['far', 'calendar']"></font-awesome-icon>
              Fecha de ingreso
            </template>
            <span data-cy="affiliation-datetime">{{ fechaIngreso }}</span>
          </el-descriptions-item>
          <el-descriptions-item span="3" content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'envelope']"></font-awesome-icon>
              Correo electrónico
            </template>
            <span data-cy="affiliation-email">{{ email }}</span>
          </el-descriptions-item>

          <el-descriptions-item span="4" content-class-name="pp-el-descriptions-item"
                                v-if="estadoRevision !== null">
            <template slot="label">
              <span class="el-icon-bell"></span>
              Estado de revisión
            </template>
            <el-tag :type="stateTag(codigoEstado)" data-cy="affiliation-state">{{ estadoRevision }}</el-tag>
          </el-descriptions-item>

        </el-descriptions>
      </template>

    </div>
  </div>
</template>

<script>
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {Descriptions, DescriptionsItem, Tag} from "element-ui";

export default {
  name: "SolicitudHistoricaDetail",
  components: {
    [Descriptions.name]: Descriptions,
    [DescriptionsItem.name]: DescriptionsItem,
    [Tag.name]: Tag,
  },
  props: {
    rut: {
      type: String,
      required: true
    },
    nombreCompleto: {
      type: String,
      required: true
    },
    fechaIngreso: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    },
    estadoRevision: {
      type: String,
      required: false,
      default: null
    },
    codigoEstado: {
      type: Number,
      required: false,
      default: 0
    }
  },
  mixins: [
    ScreenSizeMixin,
  ],
  methods: {
    stateTag(code) {
      switch (code) {
        case 1:
          return 'primary'
        case 3:
        case 6:
          return 'success'
        case 100:
          return 'danger'
        case 2:
        case 5:
          return 'info'
        case 4:
          return 'warning'
      }
      return 'primary'
    },
  }
}
</script>

<style lang="scss">
.pp-el-descriptions-item {
  padding: 22px 10px !important;
}
</style>
